import { sharedCalculatorNav, sharedCalculatorTranslations } from './calculatorShared';

export const hy = {
  // Purchased Cars (Win Cars) view tabs
  winCarsView: {
    ourDealers: 'Մեր Դիլերները',
    allAuctionWins: 'Բոլոր Աուկցիոն Հաղթանակները',
    ourDealersHint: 'Միայն մեր գրանցված դիլերներին գնված կամ վերագրված մեքենաներ:',
    allAuctionWinsHint: 'Աուկցիոն հոսքի բոլոր մեքենաները (տեղեկատվական):',
  },

  // Navigation
  nav: {
    dashboard: 'Գլխավոր',
    branches: 'Մասնաճյուղեր',
    managers: 'Մենեջերներ',
    dealers: 'Դիլերներ',
    subdealers: 'Սուբդիլերներ',
    winCars: 'Գնված Մեքենաներ',
    accounts: 'Հաշիվներ',
    auctionFees: 'Աճուրդային Վճարներ',
    deliveryCost: 'Առաքման Արժեք',
    statistics: 'Առաջարկություններ',
    watchlist: 'Դիտարկման ցանկ',
    tools: 'Գործիքներ',
    settings: 'Կարգավորումներ',
    ...sharedCalculatorNav,
  },

  // Common
  common: {
    add: 'Ավելացնել',
    edit: 'Խմբագրել',
    delete: 'Ջնջել',
    save: 'Պահպանել',
    cancel: 'Չեղարկել',
    create: 'Ստեղծել',
    update: 'Թարմացնել',
    back: 'Հետ',
    refresh: 'Թարմացնել',
    search: 'Փնտրել',
    actions: 'Գործողություններ',
    status: 'Կարգավիճակ',
    contact: 'Կապ',
    email: 'Էլ․ փոստ',
    phone: 'Հեռախոս',
    name: 'Անուն',
    username: 'Օգտանուն',
    password: 'Գաղտնաբառ',
    confirmPassword: 'Հաստատել գաղտնաբառը',
    loading: 'Բեռնվում է...',
    noDataFound: 'Տվյալներ չեն գտնվել',
    total: 'Ընդամենը',
    active: 'Ակտիվ',
    inactive: 'Ոչ ակտիվ',
    all: 'Բոլորը',
    filters: 'Զտիչներ',
  },

  watchlist: { notFound: 'չի գտնվել', remove: 'Հեռացնել ցանկից' },

  // Branches
  branches: {
    title: 'Մասնաճյուղերի կառավարում',
    addBranch: 'Ավելացնել մասնաճյուղ',
    editBranch: 'Խմբագրել մասնաճյուղը',
    createBranch: 'Ստեղծել նոր մասնաճյուղ',
    branchName: 'Մասնաճյուղի անուն',
    branchCode: 'Մասնաճյուղի կոդ',
    location: 'Գտնվելու վայր',
    country: 'Երկիր',
    city: 'Քաղաք',
    address: 'Հասցե',
    totalBranches: 'Ընդամենը մասնաճյուղեր',
    activeBranches: 'Ակտիվ մասնաճյուղեր',
    totalManagers: 'Ընդամենը մենեջերներ',
    totalDealers: 'Ընդամենը դիլերներ',
    totalSubdealers: 'Ընդամենը սուբդիլերներ',
    created: 'Ստեղծված',
    backToBranches: 'Վերադառնալ մասնաճյուղերին',
    noBranchesFound: 'Մասնաճյուղեր չեն գտնվել',
    deleteBranchConfirm: 'Համոզված ե՞ք, որ ցանկանում եք ջնջել մասնաճյուղը',
  },

  // Managers
  managers: {
    title: 'Մենեջերների կառավարում',
    addManager: 'Ավելացնել մենեջեր',
    editManager: 'Խմբագրել մենեջերը',
    createManager: 'Ստեղծել նոր մենեջեր',
    firstName: 'Անուն',
    lastName: 'Ազգանուն',
    assignToBranch: 'Նշանակել մասնաճյուղին',
    totalManagers: 'Ընդամենը մենեջերներ',
    georgiaManagers: 'Վրաստանի մասնաճյուղ',
    dubaiManagers: 'Դուբայի մասնաճյուղ',
    armeniaManagers: 'Հայաստանի մասնաճյուղ',
    activeBids: 'Ակտիվ գնանշումներ',
    monthlyRevenue: 'Ամսական եկամուտ',
    wonAuctions: 'Հաղթած աճուրդներ',
    backToManagers: 'Վերադառնալ մենեջերներին',
    noManagersFound: 'Մենեջերներ չեն գտնվել',
    deleteManagerConfirm: 'Համոզված ե՞ք, որ ցանկանում եք ջնջել մենեջերին',
  },

  // Dealers
  dealers: {
    title: 'Դիլերների կառավարում',
    addDealer: 'Ավելացնել դիլեր',
    editDealer: 'Խմբագրել դիլերը',
    createDealer: 'Ստեղծել նոր դիլեր',
    totalDealers: 'Ընդամենը դիլերներ',
    georgiaDealers: 'Վրաստանի դիլերներ',
    dubaiDealers: 'Դուբայի դիլերներ',
    armeniaDealers: 'Հայաստանի դիլերներ',
    assignToManager: 'Նշանակել մենեջերին',
    totalSubdealers: 'Ընդամենը սուբդիլերներ',
    totalSpent: 'Ընդամենը ծախսված',
    successRate: 'Հաջողության տոկոս',
    myBids: 'Իմ գնանշումները և մեքենաները',
    subdealersBids: 'Սուբդիլերների գնանշումներ և մեքենաներ',
    allBids: 'Բոլոր գնանշումները և մեքենաները',
    myActiveBids: 'Իմ ակտիվ գնանշումները',
    subdealersActiveBids: 'Սուբդիլերների ակտիվ գնանշումներ',
    totalCarsWon: 'Ընդամենը հաղթած մեքենաներ',
    backToDealers: 'Վերադառնալ դիլերներին',
    noDealersFound: 'Դիլերներ չեն գտնվել',
    deleteDealerConfirm: 'Համոզված ե՞ք, որ ցանկանում եք ջնջել դիլերին',
    deleteDealer: 'Delete Dealer',
    loadingList: 'Loading dealers...',
    filtersActiveSuffix: 'filter(s) active',
    quickSearchPlaceholder: 'Search by Name, Username, Email, or Phone...',
    ctrlFHint: 'Ctrl+F / ⌘F',
    advancedFilters: 'Advanced Filters',
    branchFilterPh: 'Branch',
    managerFilterPh: 'Manager',
    allBranches: 'All Branches',
    allManagers: 'All Managers',
    clearFilters: 'Clear Filters',
    pageTotalShowing: 'Showing',
    pageTotalOf: 'of',
    pageTotalLabel: 'total',
    auctionAccountsTitle: 'Auction Accounts',
    auctionAccountsRequired:
      'Please select at least one primary auction account (Copart, IAAI, Manheim, or ACV).',
    passwordLeaveBlank: 'Password (leave empty to keep current)',
    passwordLabel: 'Password',
    phoneLabel: 'Phone',
    selectBranch: 'Select branch',
    selectManager: 'Select manager',
    toggleOn: 'On',
    toggleOff: 'Off',
    phFirst: 'e.g., Nikoloz',
    phLast: 'e.g., Baratashvili',
    phUsername: 'e.g., dealer.ge1',
    phEmail: 'dealer@bidmanager.com',
    phPhone: '+995 555 777 777',
    accountAmPlaceholder: '🇬🇪 GE Account',
    accountUsOptional: '🇺🇸 US Account (Optional)',
    noneOption: 'None',
    unknownBranch: 'Unknown Branch',
    bidLimitLabel: 'Bid Limit',
    activeBidsAmountLabel: 'Active Bids Amount',
    activeBidsSumLimitLabel: 'Active Bids Sum Limit',
    purchasedCarsLimitLabel: 'Purchased Cars Limit',
    lotsEventSettingLabel: 'Lots Event Setting',
    purchasedLotsSettingLabel: 'Purchased Lots Setting',
    showCalculatorWidget: 'Show Calculator Widget',
    showHelperTool: 'Show Helper Tool',
    showDiscountRow: 'Show Discount Row',
    fixedDiscountAmount: 'Fixed Discount Amount ($)',
    fixedDiscountHelp: 'Fixed discount amount in USD',
    iaaiCanadaTitle: 'IAAI (Canada)',
    calculatorSettingsSection: 'Calculator Settings',
    auctionLimitsSection: 'Auction & limits',
    visibilityHide: 'Hide',
    visibilityShow: 'Show',
    visibilityPartlyShow: 'Partly Show',
    visibilityWinningLots: 'Winning Lots',
    colDealer: 'Dealer',
    colBranch: 'Branch',
    colManager: 'Manager',
    colContact: 'Contact',
    colSubdealers: 'Subdealers',
    colActiveBids: 'Active Bids',
    colTotalSpent: 'Total Spent',
    colCreatedBy: 'Created By',
    colActions: 'Actions',
    tooltips: {
      bidLimit: 'Մեկ լոտի համար առավելագույն գնանշման սահմանաչափ',
      activeBidsLimit: 'Քանի գնանշում է արդեն կատարել օգտատերը: Նոր օգտատերերի համար սահմանեք 0',
      activeBidsSumLimit: 'Առավելագույն ընդհանուր USD գումար, որը օգտատերը կարող է գնանշել բոլոր լոտերի վրա',
      purchasedCarsLimit: 'Առավելագույն մեքենաների քանակ, որոնք օգտատերը կարող է գնել',
      packageSlug: 'Օգտատիրոջ փաթեթի տեսակ',
      lotsEventSetting: 'Վերահսկում է մուտքը "Իմ գնանշումները" և "/dashboard" էջերին',
      purchasedLotsSetting: 'Վերահսկում է մուտքը վճարման պարտքերի և վճարումների պատմության էջերին',
    },
  },

  // Subdealers
  subdealers: {
    title: 'Սուբդիլերների կառավարում',
    addSubdealer: 'Ավելացնել սուբդիլեր',
    editSubdealer: 'Խմբագրել սուբդիլերը',
    createSubdealer: 'Ստեղծել նոր սուբդիլեր',
    assignToDealer: 'Նշանակել դիլերին',
    dealer: 'Դիլեր',
    branch: 'Մասնաճյուղ',
    manager: 'Մենեջեր',
    totalSpent: 'Ընդամենը ծախսված',
    wonAuctions: 'Հաղթած աճուրդներ',
    activeBids: 'Ակտիվ գնանշումներ',
    backToSubdealers: 'Վերադառնալ սուբդիլերներին',
    noSubdealersFound: 'Սուբդիլերներ չեն գտնվել',
    deleteSubdealerConfirm: 'Համոզված ե՞ք, որ ցանկանում եք ջնջել սուբդիլերին',
    tooltips: {
      bidLimit: 'Մեկ լոտի համար առավելագույն գնանշման սահմանաչափ',
      activeBidsLimit: 'Քանի գնանշում է արդեն կատարել օգտատերը: Նոր օգտատերերի համար սահմանեք 0',
      activeBidsSumLimit: 'Առավելագույն ընդհանուր USD գումար, որը օգտատերը կարող է գնանշել բոլոր լոտերի վրա',
      purchasedCarsLimit: 'Առավելագույն մեքենաների քանակ, որոնք օգտատերը կարող է գնել',
      packageSlug: 'Օգտատիրոջ փաթեթի տեսակ',
      lotsEventSetting: 'Վերահսկում է մուտքը "Իմ գնանշումները" և "/dashboard" էջերին',
      purchasedLotsSetting: 'Վերահսկում է մուտքը վճարման պարտքերի և վճարումների պատմության էջերին',
    },
  },

  // Bids & Cars
  bids: {
    lotNumber: 'Լոտի համար',
    vin: 'VIN',
    vehicle: 'Մեքենա',
    bidAmount: 'Գնանշման գումար',
    status: 'Կարգավիճակ',
    bidder: 'Գնանշող',
    subdealer: 'Սուբդիլեր',
    won: 'ՀԱՂԹԵԼ',
    active: 'ԱԿՏԻՎ',
    lost: 'ՊԱՐՏՎԵԼ',
    totalBids: 'Ընդամենը գնանշումներ',
    bidsAndCars: 'Գնանշումներ և մեքենաներ',
    noBidsFound: 'Գնանշումներ չեն գտնվել',
  },

  layout: {
    footerBrand: 'Bidmanager Համակարգ',
  },

  // Auth
  auth: {
    login: 'Մուտք',
    logout: 'Ելք',
    welcomeBack: 'Բարի վերադարձ',
    signIn: 'Մուտք գործել',
    profile: 'Անձնական էջ',
    loginSubtitle: 'Ավտոմեքենաների աճուրդի կառավարման համակարգ',
    usernamePlaceholder: 'Օգտանուն',
    passwordPlaceholder: 'Գաղտնաբառ',
    signingIn: 'Մուտք...',
    loginFailed: 'Մուտքը ձախողվեց: Ստուգեք տվյալները։',
    connectionError: 'Կապի սխալ: Ստուգեք ինտերնետը և նորից փորձեք։',
    forgotPasswordQuestion: 'Մոռացե՞լ եք գաղտնաբառը',
    forgotPasswordTitle: 'Գաղտնաբառի վերականգնում',
    forgotPasswordHint: 'Մուտքագրեք էլ․ փոստը կամ օգտանունը վերականգնման հղում ստանալու համար։',
    resetByEmail: 'Էլ․ փոստով',
    resetByUsername: 'Օգտանունով',
    emailPlaceholder: 'Մուտքագրեք էլ․ փոստը',
    forgotUsernamePlaceholder: 'Մուտքագրեք օգտանունը',
    sending: 'Ուղարկվում է...',
    sendResetEmail: 'Ուղարկել վերականգնման նամակ',
    checkEmailTitle: 'Ստուգեք էլ․ փոստը',
    checkEmailBody:
      'Եթե նման հաշիվ գոյություն ունի, վերականգնման նամակ է ուղարկվել։ Ստուգեք փոստարկղը։',
    backToLogin: 'Վերադառնալ մուտքի էջ',
    provideEmailOrUsername: 'Մուտքագրեք էլ․ փոստ կամ օգտանուն',
    enterEmailAddress: 'Մուտքագրեք էլ․ փոստի հասցեն',
    enterUsernameRequired: 'Մուտքագրեք օգտանունը',
    requestFailedLater: 'Հարցումը չհաջողվեց: Փորձեք ավելի ուշ։',
  },

  // Stats
  stats: {
    statistics: 'Վիճակագրություն',
    dashboard: 'Վահանակ',
  },

  // Dashboard
  dashboard: {
    systemAdminDashboard: 'Համակարգի ադմինիստրատորի վահանակ',
    branchManagerDashboard: 'Մասնաճյուղի մենեջերի վահանակ',
    dealerDashboard: 'Դիլերի վահանակ',
    yourAuctionDashboard: 'Ձեր աճուրդների վահանակ',
    welcomeToDashboard: 'Բարի գալուստ Bidmanager վահանակ',
    welcomeBack: 'Բարի վերադարձ',
    systemOverview: 'համակարգի',
    branchOverview: 'մասնաճյուղի',
    activityOverview: 'գործունեության',
    overview: 'ակնարկ',
    hereIsYour: 'Ահա ձեր',
    downloadApp: 'Ներբեռնել հավելվածը',
    downloadAppDesc: 'Ներբեռնեք մեր բջջային հավելվածը աճուրդներ կառավարելու համար',
    downloadNow: 'Ներբեռնել հիմա',
    yourManager: 'Ձեր մենեջերը',
    yourManagerDesc: 'Կապվեք ձեր մենեջերի հետ օգնության համար',
    whatsapp: 'WhatsApp',
    viber: 'Viber',
    tarifPlan: 'Սակագնային պլան',
    basic: 'Հիմնական',
    planLimits: '5 մեքենա • $10,000 սահմանաչափ',
    upgradePlan: 'Բարձրացնել պլանը',
    quickOverview: 'Արագ ակնարկ',
    priceList: 'Գների ցանկ',
    oneActive: '1 Ակտիվ',
    twoOnline: '2 Առցանց',
    twoActive: '2 Ակտիվ',
    name: 'Անուն',
    user: 'Օգտատեր',
    account: 'Հաշիվ',
    auction: 'Աճուրդ',
    activity: 'Գործունեություն',
    action: 'Գործողություն',
    managePriceLists: 'Կառավարել գների ցանկերը',
    manageSubdealers: 'Կառավարել սուբդիլերներին',
    manageAccounts: 'Կառավարել հաշիվները',
    online: 'Առցանց',
    systemMetrics: 'Համակարգի ցուցանիշներ',
    branchPerformance: 'Մասնաճյուղի արդյունավետություն',
    yourActivity: 'Ձեր գործունեությունը',
    totalBranches: 'Ընդամենը մասնաճյուղեր',
    activeBranchesWorldwide: 'Ակտիվ մասնաճյուղեր ամբողջ աշխարհում',
    branchManagers: 'Մասնաճյուղի մենեջերներ',
    acrossAllBranches: 'Բոլոր մասնաճյուղերում',
    totalRevenue: 'Ընդհանուր եկամուտ',
    totalPlatformRevenue: 'Պլատֆորմի ընդհանուր եկամուտ',
    mySubdealers: 'Իմ սուբդիլերները',
    activeInYourBranch: 'Ակտիվ ձեր մասնաճյուղում',
    currentlyInProgress: 'Ներկայումս ընթացքում',
    byYourBranch: 'Ձեր մասնաճյուղի կողմից',
    currentlyBidding: 'Ներկայումս գնանշում',
    thisMonth: 'Այս ամիս',
    totalBidsPlaced: 'Ընդհանուր կատարված գնանշումներ',
    totalWonAuctions: 'Ընդհանուր հաղթած աճուրդներ',
  },

  // Form validation
  validation: {
    required: 'Այս դաշտը պարտադիր է',
    invalidEmail: 'Սխալ էլ․ փոստի հասցե',
    passwordMismatch: 'Գաղտնաբառերը չեն համընկնում',
    minLength: 'Նվազագույն երկարությունը',
    maxLength: 'Առավելագույն երկարությունը',
  },

  // Notifications
  notifications: {
    createSuccess: 'Հաջողությամբ ստեղծվել է',
    updateSuccess: 'Հաջողությամբ թարմացվել է',
    deleteSuccess: 'Հաջողությամբ ջնջվել է',
    error: 'Սխալ է տեղի ունեցել',
  },

  ...sharedCalculatorTranslations,

  // Delivery Cost
  deliveryCost: {
    title: 'Առաքման արժեքի կառավարում',
    addNew: 'Ավելացնել նոր տեղակայություն',
    editLocation: 'Խմբագրել տեղակայությունը',
    location: 'Տեղակայություն',
    fee: 'Արժեք',
    notes: 'Նշումներ',
    auction: 'Աճուրդ',
    country: 'Երկիր',
    armenia: 'Հայաստան',
    georgia: 'Վրաստան',
    auctionCopart: 'Copart',
    auctionIaai: 'IAAI',
    auctionManheim: 'Manheim',
    statsCopart: 'Copart:',
    statsIaai: 'IAAI:',
    statsManheim: 'Manheim:',
    totalLocations: 'Ընդամենը տեղակայություններ',
    searchLocation: 'Փնտրել տեղակայություն',
    searchPlaceholder: 'օրինակ՝ Ատլանտա, Հյուստոն...',
    addNotes: 'Ավելացնել նշումներ...',
    notesPlaceholder: 'Ընտրովի նշումներ այս տեղակայության մասին...',
    confirmDelete: 'Հաստատել ջնջումը',
    confirmDeleteMessage: 'Համոզված եք, որ ցանկանում եք ջնջել առաքման այս արժեքը: Այս գործողությունը հնարավոր չէ հետարկել:',
    createSuccess: 'Առաքման արժեքը հաջողությամբ ստեղծվել է',
    updateSuccess: 'Առաքման արժեքը հաջողությամբ թարմացվել է',
    deleteSuccess: 'Առաքման արժեքը հաջողությամբ ջնջվել է',
    loadError: 'Չհաջողվեց բեռնել առաքման արժեքները',
    saveError: 'Չհաջողվեց պահպանել առաքման արժեքը',
    deleteError: 'Չհաջողվեց ջնջել առաքման արժեքը',
    validationError: 'Տեղակայությունը և արժեքը պարտադիր են',
  },
};

